import { render, staticRenderFns } from "./collapse-text.vue?vue&type=template&id=5223df74"
import script from "./collapse-text.vue?vue&type=script&lang=js"
export * from "./collapse-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5223df74')) {
      api.createRecord('5223df74', component.options)
    } else {
      api.reload('5223df74', component.options)
    }
    module.hot.accept("./collapse-text.vue?vue&type=template&id=5223df74", function () {
      api.rerender('5223df74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/collapse-text.vue"
export default component.exports